module.exports = __webpack_public_path__ + "static/img/CX.224638bf.png";